import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoadingService } from '../../../shared/services/loading.service';
import { SetupEquipmentService } from '../../setup-equipment/setup-equipment.service';
import { NotificationsService } from 'angular2-notifications';
import { CryptoService } from '../../../../app/services/crypto.service';

@Component({
  selector: 'app-request-new-chain-model',
  templateUrl: './request-new-chain-model.component.html',
  styleUrls: ['./request-new-chain-model.component.scss']
})
export class RequestNewChainModelComponent implements OnInit {
  email = '';
  emailControl: FormControl;
  saving: boolean;
  model = '';
  make = '';
  modelControl: FormControl;
  makeControl: FormControl;
  chainDescControl: FormControl;
  chainDescription='';
  fg: FormGroup;
  
  constructor(@Inject(MAT_DIALOG_DATA) private _data: any,public dialogRef: MatDialogRef<RequestNewChainModelComponent>,
   private _equipmentService: SetupEquipmentService,private _notification: NotificationsService, private _aesService: CryptoService

  ) { }

  ngOnInit(): void {
    
    this.GetUserEmail()
    this.model= this._data.modelName;
    this.make=this._data.MakeName;
    this.emailControl = new FormControl(this.email, [
      Validators.required,
      Validators.email,
    ]);
    this.modelControl = new FormControl(this.model, [
      Validators.required,
    ]);
    this.makeControl = new FormControl(this.make, [
      Validators.required,
    ]);
    this.fg = new FormGroup({
      modelControl: this.modelControl,
    });
  }

  save() {
   
    this.saving = true;
    this._equipmentService.requestANewChainEmailSend(this.email, this.model,this.make, this.chainDescription).subscribe(r => {
      this.saving = false;
      if (r) {
        this._notification.success('Success', 'We will contact you shortly');
        this.dialogRef.close();
      }      else{
        this._notification.error('Operation Failed');
      }
    }, error => {
      this.saving = false;
      this._notification.error('Operation Failed');
      console.log(error);
    });
  }

  GetUserEmail() {
    this._equipmentService.GetUserEmail().subscribe(result => {
      if(result!=null){
        //this.email = result;
        this.email = this._aesService.decrypt(result);
      }
    });
  }

  onNoClick() {
    this.dialogRef.close(false);
  }
}
